export const SCHOOL_FEATURE_KEY = 'school';
